import { Flex } from '@chakra-ui/react';
import { keyframes } from '@emotion/react';

const badge = keyframes`
0% {
  top: 0%;
  left: 0%;
  height: 100%;
  width: 100%;
}

100% {
  top: -100%;
  left: -100%;
  height: 300%;
  width: 300%;
}
`;

export function PayflipBadge(): JSX.Element {
  return (
    <Flex
      data-testid="payflip-badge"
      position="absolute"
      right="space_unit.x4"
      borderRadius="50%"
      w="10px"
      h="10px"
      alignItems="center"
      justifyContent="center"
      _before={{
        content: "''",
        position: 'absolute',
        top: '0%',
        left: '0%',
        height: '100%',
        width: '100%',
        borderRadius: '50%',
        backgroundColor: 'palette_primary.0',
        animation: `${badge} 750ms linear 3`
      }}
      _after={{
        content: "''",
        position: 'absolute',
        top: '0%',
        left: '0%',
        height: '100%',
        width: '100%',
        borderRadius: '50%',
        backgroundColor: 'palette_primary.100'
      }}
    />
  );
}
